import { render } from "./OvPartInfoModal.vue?vue&type=template&id=51d930c5&scoped=true"
import script from "./OvPartInfoModal.vue?vue&type=script&lang=js"
export * from "./OvPartInfoModal.vue?vue&type=script&lang=js"

import "./OvPartInfoModal.vue?vue&type=style&index=0&id=51d930c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d930c5"],['__file',"src/components/OvPartInfoModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51d930c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51d930c5', __exports__)) {
    api.reload('51d930c5', __exports__)
  }
  
  module.hot.accept("./OvPartInfoModal.vue?vue&type=template&id=51d930c5&scoped=true", () => {
    api.rerender('51d930c5', render)
  })

}


export default __exports__